export const querySelector = state => state.search.query

let previousSuggestions

export const suggestionsSelector = (
  state,
  { suggestionType, value, exclusions = [], count = 5 }
) => {
  try {
    const suggestions = state.suggestions[suggestionType][value]
    if (suggestions === 'pending' || suggestions === undefined) {
      return previousSuggestions || []
    } else {
      previousSuggestions = suggestions
        .filter(suggestion => !exclusions.includes(suggestion))
        .slice(0, count)
      return previousSuggestions
    }
  } catch (e) {
    return undefined
  }
}

export const tokensSelector = state => {
  try {
    return state.search.query.split(' ')
  } catch (e) {
    return undefined
  }
}

export const newSearchSelector = state => {
  try {
    return !Object.keys(state.search.results).includes(state.search.query + '')
  } catch (e) {
    return undefined
  }
}

export const searchIsPendingSelector = state => {
  try {
    return state.search.results[state.search.query] === 'pending'
  } catch (e) {
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/selectors/search.js